import axios from 'axios';
import { useQuery } from '@tanstack/react-query';

import { ppaUrls } from 'config/urls';

export function useFetchDashboard() {
    const { data: dashboardData, isLoading, isPending } = useQuery({
        queryKey: ['dashboard-data'],
        queryFn: async () => {
            const response = await axios.get(ppaUrls.getDashboardUrl);
            return response.data;
        },
    });

    return { dashboardData, isLoading, isPending };
}
